import { Component, OnInit } from '@angular/core';
import { BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { Modal, overlayConfigFactory } from 'ngx-modialog';
import { ActivatedRoute } from '@angular/router';
import { ProviderItem } from '../../../utils/objects/organization-parameter';
import { ApiService } from '../../../utils/services/api.service';
import { FlightProviderInfoComponent } from '../flight-provider-info/flight-provider-info.component';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs';
import {PROVIDER_TYPES, TV_PROVIDERS} from '../../../utils/constants/constants';

@Component({
  selector: 'app-agency-providers',
  templateUrl: './agency-providers.component.html',
  styleUrls: ['./agency-providers.component.scss']
})
export class AgencyProvidersComponent implements OnInit {

  public providers: Array<ProviderItem> = [];
  public organizationID;
  public readonly TV_PROVIDERS = TV_PROVIDERS;

  constructor(public modal: Modal,
    private activatedRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private apiService: ApiService) {
  }

  ngOnInit() {

    this.organizationID = this.activatedRoute.snapshot.parent.params.id;
    this.providers = this.activatedRoute.snapshot.data.providers;

  }
  addFlightProvider() {
    const organization = this.activatedRoute.snapshot.parent.data.organizationData;
    let dialogRef = this.modal.open(
      FlightProviderInfoComponent,
      overlayConfigFactory({
        size: 'lg',
        isAgencyView: true,
        organizationID: this.organizationID,
        organizationSegment: organization ? organization.segment : null
      }, BSModalContext));

    dialogRef.result.then((result) => {
      if (result) {
        result.forEach((response) => {
          if (PROVIDER_TYPES.includes(response.data.type)) {
            let isProviderExists = false;
            this.providers.forEach((providerItem) => {
              if (providerItem.provider === response.data.context) {
                isProviderExists = true;
                providerItem[response.data.key] = response.data;
              }
            });

            if (!isProviderExists) {
              let providerItem = new ProviderItem();
              providerItem.provider = response.data.context;
              providerItem.type = response.data.type;
              providerItem.id = response.data.id;
              providerItem[response.data.key] = response.data;
              this.providers.push(providerItem);
            }
          }
        });
      }
    });
  }

  deleteProvider(context, itemIndex) {
    this.apiService.deleteOrganizationProvider(this.organizationID, context).subscribe(res => {
      this.notificationsService.success('Success', 'Delete operation is successful!');
      this.providers.splice(itemIndex, 1);
    }, err => {
      this.notificationsService.error('Failed', 'Delete operation failed!');
    })
  }

  openFlightProviderDetail(providerItem) {
    let dialogRef = this.modal.open(
      FlightProviderInfoComponent,
      overlayConfigFactory({
        size: 'lg',
        organizationID: this.organizationID,
        isAgencyView: true,
        providerItem: providerItem
      }, BSModalContext));

    dialogRef.result.then((result) => {
    });
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/frames/agency-providers/agency-providers.component.ts